import React from "react";
import { Card, Typography, Descriptions, Tag } from "antd";
import {
  BankOutlined,
  ApartmentOutlined,
  CreditCardOutlined,
  DollarOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

export function BankAccountCard({
  account,
  formatAccountNumber,
  formatMoney,
  getBankLabel,
}) {
  return (
    <Card
      title={
        <span>
          <BankOutlined className="mr-2" />
          Банкны данс
        </span>
      }
      bordered={false}
      className="rounded-xl shadow-sm"
    >
      <Descriptions column={1} size="middle" labelStyle={{ width: 180 }}>
        <Descriptions.Item
          label={
            <span>
              <CreditCardOutlined className="mr-2" />
              Дансны дугаар
            </span>
          }
        >
          <Text strong>
            {formatAccountNumber(account?.accountNumber)}
          </Text>
        </Descriptions.Item>

        <Descriptions.Item label="Банк">
          <Tag color="blue">{getBankLabel(account?.bank)}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Валют">
          <Tag color="green">{account?.currency ?? "-"}</Tag>
        </Descriptions.Item>

        {/* Gmail үлдэгдэл */}
        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Gmail үлдэгдэл
            </span>
          }
        >
          <Text strong className="text-base">
            {formatMoney(account?.gmailBalance, account?.currency)}
          </Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Эхний үлдэгдэл
            </span>
          }
        >
          <Text strong className="text-base">
            {formatMoney(account?.balance, account?.currency)}
          </Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Хийсвэр үлдэгдэл
            </span>
          }
        >
          <Text strong className="text-base">
            {formatMoney(account?.walletBalance, account?.currency)}
          </Text>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}

export function InstitutionCard({
  institution,
  getInstitutionTypeLabel,
}) {
  return (
    <Card
      title={
        <span>
          <ApartmentOutlined className="mr-2" />
          Байгууллага
        </span>
      }
      bordered={false}
      className="h-full rounded-xl shadow-sm"
    >
      {institution ? (
        <Descriptions column={1} size="middle" labelStyle={{ width: 140 }}>
          <Descriptions.Item label="Байгууллагын нэр">
            <Text strong>{institution.name}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Байгууллагын төрөл">
            <Tag color="purple">
              {getInstitutionTypeLabel(institution.type)}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Text type="secondary">
          Холбогдсон байгууллага байхгүй
        </Text>
      )}
    </Card>
  );
}